/** Wait for an amount to stop changing before requesting its fee/route quote. */
export const AMOUNT_QUOTE_DEBOUNCE_MS = 2_500;
